export const companiesReportInitialValues = {
  agrupamento: 0,
  tiposPessoaFisica: [],
  tiposEmpresa: [],
  usuarios: [],
  dtVencimento: { dtInicio: '', dtFim: '' },
  dtEmissao: { dtInicio: '', dtFim: '' },
  situacaoCadastro: 3,
  situacaoCrc: 3,
  tipoCadastro: 3,
  municipios: [],
  boExibirResumo: true,
};

export const companySituationReportInitialValues = {
  tipoCadastro: 3,
  tiposEmpresa: [],
  tiposPessoaFisica: [],
  empresas: [],
  dtVencimento: { dtInicio: '', dtFim: '' },
  situacaoCadastro: 3,
  situacaoCrc: 3,
  nmFantasia: '',
  empresasRazao: [],
  empresasFantasia: [],
  nuDocumentoOperador: ""
};
